module.exports = __webpack_public_path__ + "img/3.6cf5f7bf.jpg";